export interface FindClauseProps {
  limit?: string | number
  offset?: string | number
  sort?: string
  where?: string
}

export class FindClause {
  public static make(option?: FindClauseProps): any {
    return {
      limit: option.limit ?? 10,
      sort: option.sort ?? '',
      offset: option.offset ?? 0,
      xwhere: option.where ?? ''
    }
  }
}
